import React from 'react';

export function StarWithBorder () {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        fill="#DEBA12"
        stroke="#fff"
        d="M10.476 3.845L10 2.382l-.476 1.463-1.459 4.492H1.803l1.246.904 3.82 2.776L5.41 16.51l-.476 1.463 1.245-.904L10 14.292l3.82 2.776 1.246.904-.476-1.463-1.46-4.492 3.821-2.776 1.245-.904h-6.261l-1.46-4.492z"
      />
    </svg>
  );
}
